import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from "react-router-dom";
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import SvgIcon from '@material-ui/core/SvgIcon';
import Page from '../Page/Page';
import PercentIcon from '../../icons/percent.svg';
import utils, { currency, placeholderRows } from '../../utils';
import Attachments from '../Attachments/Attachments';
import InfoTile from '../InfoTile/InfoTile';
import Placeholder from '../Placeholder/Placeholder';
import VientiRivi from './VientiRivi';
import RefreshButton from '../RefreshButton/RefreshButton';


@inject('receiptStore', 'viewStore')
@withRouter
@observer
class Receipt extends Component {
  componentDidMount() {
    this.props.receiptStore.setCurrent(this.props.match.params.id);
  }

  render() {
    const { receiptStore, viewStore } = this.props;
    const kuitti = receiptStore.receipt;

    return (
      <Page
        title={kuitti.TOSITENUMERO ? 'Tosite #' + kuitti.TOSITENUMERO : 'Tosite'}
        navigationAction={
          <IconButton
            onClick={receiptStore.hideReceipt}
            color="inherit"
          >
            <CloseIcon />
          </IconButton>
        }
        actions={
          <div className="row">
            <IconButton
              color={viewStore.showVat ? 'inherit' : 'default'}
              onClick={viewStore.toggleVat}
            >
              <SvgIcon>
                <PercentIcon />
              </SvgIcon>
            </IconButton>

            <RefreshButton
              loading={receiptStore.isLoading}
              onClick={receiptStore.refresh}
            />
          </div>
        }
      >
        <div className="padding-md">
          <Typography component={'span'} variant="h5" className="text-center">
            <Placeholder size={8}>
              {kuitti.tositelaji && kuitti.tositelaji.SELITE}
            </Placeholder>
          </Typography>

          <div className="row margin-md-vert" style={{ justifyContent: 'space-around' }}>
            <InfoTile title="Päivämäärä" value={utils.ymd2dmy(kuitti.PAIVAMAARA)} />
          </div>

          {
            kuitti.LISATIETO &&
            <div className="row margin-md-vert" style={{ justifyContent: 'space-around' }}>
              <InfoTile title="Selite" value={kuitti.LISATIETO} />
            </div>
          }
        </div>

        {
          kuitti.palkat &&
          !!kuitti.palkat.length &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              Palkat
            </Typography>

            <table className="full-width inforow-title">
              <tbody>
                {
                  kuitti.palkat.map((row, idx) =>
                    <tr key={idx}>
                      <td>
                        {row.tyontekija.SUKUNIMI} {row.tyontekija.ETUNIMET}
                      </td>
                      <td className="text-right">
                        {utils.ymd2dmy(row.SUORITUSPVM)}
                      </td>
                      <td className="text-right">
                        {currency(row.BRUTTO.toFixed(2))}
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
        }

        {
          kuitti.ostolaskut &&
          !!kuitti.ostolaskut.length &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              Ostolaskut
            </Typography>

            <table className="full-width inforow-title">
              <tbody>
                {
                  kuitti.ostolaskut.map((row, idx) =>
                    <tr key={idx}>
                      <td>
                        <Link to={{
                          pathname: `/ostolaskut/${row.ORLASKUID}`,
                          state: { skeleton: Object.assign({}, row) }
                        }}>
                          {row.ORLASKUNUMERO}
                        </Link>
                      </td>
                      <td>
                        {row.TOIMITTAJANIMI}
                      </td>
                      <td className="text-right">
                        {utils.ymd2dmy(row.LASKUPVM)}
                      </td>
                      <td className="text-right">
                        {currency(row.LASKUNSUMMA)}
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
        }

        {
          kuitti.laskut &&
          !!kuitti.laskut.length &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              Laskut
            </Typography>

            <table className="full-width inforow-title">
              <tbody>
                {
                  kuitti.laskut.map((row, idx) =>
                    <tr key={idx}>
                      <td>
                        <Link to={{
                          pathname: `/laskut/${row.MRLASKUID}`,
                          state: { skeleton: Object.assign({}, row) }
                        }}>
                          {row.MRLASKUNUMERO}
                        </Link>
                      </td>
                      <td>
                        {row.LASKUTUSASIAKASNIMI}
                      </td>
                      <td className="text-right">
                        {utils.ymd2dmy(row.LASKUNPVM)}
                      </td>
                      <td className="text-right">
                        {currency(row.LASKUNSUMMA)}
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
        }

        {
          !kuitti.vientirivit &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              <Placeholder size={6} />
            </Typography>

            <table className="full-width">
              <thead>
                <tr>
                  <td></td>
                  <td></td>
                  <td className="cell-sum"></td>
                </tr>
              </thead>
              <tbody>
                {
                  placeholderRows(4).map((_, idx) =>
                    <tr key={idx}>
                      <td>
                        <Placeholder size={4} />
                      </td>
                      <td>
                        <Placeholder size={8} />
                      </td>
                      <td className="text-right">
                        <Placeholder size={4} />
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
        }

        <div className="padding-md">
          <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
            Kirjanpito
          </Typography>

          <table className="full-width">
            <thead>
              <tr>
                <td></td>
                <td className="cell-sum"></td>
                <td className="cell-sum"></td>
              </tr>
            </thead>
            {
              kuitti.vientirivit ?
                kuitti.vientirivit.map((row, idx) =>
                  <VientiRivi
                    key={idx}
                    data={row}
                    detailed={viewStore.showVat}
                  />
                ) :
                <tbody>
                  {
                    placeholderRows(6, 2).map((_, idx) =>
                      <tr key={idx}>
                        <td>
                          <Placeholder size={8} />
                        </td>
                        <td>
                          <Placeholder size={4} />
                        </td>
                        <td className="text-right">
                          <Placeholder size={4} />
                        </td>
                      </tr>
                    )
                  }
                </tbody>
            }
          </table>
        </div>

        {
          kuitti.liitteet &&
          !!kuitti.liitteet.length &&
          <div className="padding-md">
            <Typography component={'span'} variant="body1" style={{ opacity: .8, marginBottom: 8 }}>
              Liitteet
            </Typography>

            <Attachments
              attachments={kuitti.liitteet}
              type="kuitit"
            />
          </div>
        }
      </Page>
    );
  }
}

export default Receipt;
